"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _$previous = babelHelpers.interopRequireDefault(require("$previous"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

// import checkObjectAccess from 'access-control/check-object-access';
var maybeJson = function maybeJson(json, value) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return value;
  }
};

var DocumentCard =
/*#__PURE__*/
function (_OriginalDocumentCard) {
  babelHelpers.inherits(DocumentCard, _OriginalDocumentCard);

  function DocumentCard() {
    babelHelpers.classCallCheck(this, DocumentCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(DocumentCard).apply(this, arguments));
  }

  return DocumentCard;
}(_$previous.default);

exports.default = DocumentCard;